export const image = {
  medium:
    'https://assets.riparide.com/landing_pages/about_us/header/desktop_1x.jpg',
  large:
    'https://assets.riparide.com/landing_pages/about_us/header/desktop_2x.jpg',
}
